import type React from "react";

import { Stack } from "@/design-system/Stack";

export function AppHeader({
  children,
  bgImage,
  profileImage,
}: React.PropsWithChildren<{ bgImage?: string; profileImage?: React.ReactNode }>): React.ReactNode {
  return (
    <header className="relative flex items-center justify-center bg-background-tertiary">
      <figure className="relative aspect-video w-full bg-cover bg-center">
        {bgImage ? <img className="absolute inset-0 size-full object-cover" src={bgImage} alt="" /> : null}
      </figure>
      <figure className="absolute right-5 -bottom-8 z-10 flex size-thumbnail-prominent items-center justify-center overflow-hidden rounded-full border-2 border-background-default bg-background-default bg-cover bg-center">
        {profileImage}
      </figure>
      {children}
    </header>
  );
}

export function AppUserItem({ fullName, subTitle }: { fullName: string; subTitle: string }): React.ReactNode {
  return (
    <article className="-mb-px flex items-center bg-background-default first-of-type:border-t-0">
      <span className="m-space-sm flex size-icon-display items-center justify-center rounded-full border border-border-secondary bg-background-secondary p-space-sm">
        <svg className="w-full" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 22 24">
          <path
            stroke="#000"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.458"
            d="M20.954 23.176v-2.43a4.858 4.858 0 00-4.858-4.858H6.379a4.858 4.858 0 00-4.858 4.859v2.429"
          />
          <path
            stroke="#000"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.458"
            d="M11.237 11.03a4.858 4.858 0 100-9.717 4.858 4.858 0 000 9.717z"
          />
        </svg>
      </span>
      <Stack gap="xs">
        <p className="text-overline-emphasis text-text-primary">{fullName}</p>
        <p className="text-overline text-text-primary">{subTitle}</p>
      </Stack>
    </article>
  );
}
